import { DEFAULT_CHAIN_ID } from '@/lib/chains'
import ZoraAccountManager from '@ourzora/api/src/abis/ZoraAccountManager'
import { encodeOwners, NONCE } from '@ourzora/api/src/utils/contract/encodeOwners'
import { contracts } from '@ourzora/chains'
import { Address, PublicClient } from 'viem'

/**
 * Calculates the deterministic smart wallet address for a given set of owners
 * @param publicClient - The public client to use for the contract call
 * @param owners - The list of owner addresses
 * @returns The deterministic smart wallet address
 */
export const calculateSmartWalletAddress = async (
  publicClient: PublicClient,
  owners: Address[]
): Promise<Address> => {
  const encodedOwners = encodeOwners(owners)

  return publicClient.readContract({
    address: contracts.ZoraAccountManager[DEFAULT_CHAIN_ID],
    abi: ZoraAccountManager,
    functionName: 'getAddress',
    args: [encodedOwners, NONCE],
  })
}
